/**
 * Card Component
 * AIDLC Administrative Backend
 *
 * Reusable card container following LDAJA design system.
 * White background, subtle border, optional header and footer.
 */

import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

export function Card({
  children,
  title,
  subtitle,
  action,
  className = '',
  noPadding = false,
}: CardProps) {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg ${className}`}>
      {/* Header */}
      {(title || action) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <div>
            {title && (
              <h3 className="text-sm font-semibold text-ldaja-black">{title}</h3>
            )}
            {subtitle && (
              <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
            )}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}

      {/* Body */}
      <div className={noPadding ? '' : 'p-4'}>{children}</div>
    </div>
  );
}
